import React from 'react';
import PropTypes from 'prop-types';

import { withCommon } from '../../components';
import { resolveLocalizedValue } from '../../common/utils';

/**
 * @file Represents About Us page
 *
 * @param {string} email - user email
 * @param {string} language - active site language
 * @param {string} siteName - site config.contactUs
 *
 * @author A.Green
 */

const ContactUs = withCommon({
    store: ({ store }) => ({
        language: store.user.language,
        config: store.modifiedConfig,
        viewSize: store.site.status.viewSize,
    }),
    propTypes: {
        email: PropTypes.string,
        language: PropTypes.string.isRequired,
    },
    isTrans: true,
})(({ trans, language, config, viewSize }) => {
    const contactCopy = resolveLocalizedValue(config.contactUs, language) || {};

    return (
        <div className={`ll-page help help-${viewSize}`}>
            <div className="help__header">{trans('Contact Information')}</div>
            <div className="help__description">
                <p>{contactCopy.contactAnswersRow}</p>
                <p>{contactCopy.contactEmailRow}</p>
            </div>
            <div className="help__tiles-container">
                {config.contactUs.showSupportBlock && (
                    <div className="help__tile">
                        <div className="help__tile-text-container">
                            <span className="help__tile-text__title">
                                {trans('Live support')}
                            </span>
                            <span className="help__tile-text">
                                {contactCopy.liveSupportBlock}
                            </span>
                        </div>
                    </div>
                )}
                <div className="help__tile">
                    <div className="help__tile-text-container">
                        {!!config.siteConfig.email && <span className="help__tile-text__title">{trans('E-Mail')}</span>}
                        <span className="help__tile-text">
                            {contactCopy.emailBlock}
                        </span>
                        {(config.contactUs && !!config.siteConfig.email) ? <a href={`mailto:${config.siteConfig.email}`}>{config.siteConfig.email}</a> : ''}
                    </div>
                </div>
            </div>
            <div className="help__description">
                <p>{contactCopy.notForgetRow}</p>
            </div>
        </div>
    );
});

//...

export default ContactUs;
